import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const COLS = [
  { h: "Contracts", l: [["Care Homes", "/sectors/care-homes"], ["Schools", "/sectors/schools"], ["Corporate", "/sectors/corporate"]] },
  { h: "Work with us", l: [["Chef Agency", "/chefs"], ["Flapjack Shop", "/flapjack"], ["Resources", "/resources"], ["Admin", "/admin"]] },
];

export const Footer = () => (
  <footer className="relative overflow-hidden bg-[#141412] text-stone-300 grain" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 pt-24 pb-10">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-6">
          <Logo className="h-12" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-stone-400">
            Contract catering for UK care homes, schools and workplaces. Agency chefs for our projects. And Flapjack, our pancake & waffle mix.
          </p>
          <p className="mt-6 text-sm text-stone-400" data-testid="footer-contact">
            <a href="mailto:culifectcatering@gmail.com" className="text-stone-200 hover:text-[#C59B27]">culifectcatering@gmail.com</a> · West Sussex, UK
          </p>
        </div>
        {COLS.map((c) => (
          <div key={c.h} className="md:col-span-3">
            <p className="eyebrow text-[#C59B27]">{c.h}</p>
            <ul className="mt-5 space-y-3">
              {c.l.map(([t, to]) => (
                <li key={to}>
                  <Link to={to} className="text-stone-200 transition-colors hover:text-[#C59B27]" data-testid={`footer-link-${to.replaceAll("/", "-").slice(1)}`}>
                    {t}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="mt-20 select-none font-display text-[22vw] leading-[0.8] tracking-tighter text-white/[0.06]" aria-hidden="true">
        Culifect
      </p>
      <div className="mt-6 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 text-xs text-stone-400 sm:flex-row">
        <span>© {new Date().getFullYear()} Culifect Catering. All rights reserved.</span>
        <span>Flapjack is a Culifect brand.</span>
      </div>
    </div>
  </footer>
);
